<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#005f32"
      spinner="bar-fade-scale"
    />
    <v-snackbar v-model="showsnackbar" color="black" right>
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex align-self-center>
        <!-- <v-card> -->
        <v-card-title class="elevation-0">
          <!-- <span class="itemHeading">My Loans applications</span> -->
          <v-spacer></v-spacer>
          <v-btn
            outlined
            color="green"
            @click="$router.push('/MySalaryAdvanceApplications')"
            >Salary advance applications</v-btn
          >

          <v-flex xs12 align-self-center py-2>
            <v-layout wrap justify-end>
              <v-flex align-self-center xl3 lg3 md3 pb-2 sm3 xs12 px-2>
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="fromDate"
                      label="From Date"
                      outlined
                      class="rounded-xl"
                      hide-details
                      dense
                      v-bind="attrs"
                      v-on="on"
                      clearable
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="fromDate"
                    no-title
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex align-self-center xl3 lg3 md3 pb-2 sm3 xs12 px-2>
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="toDate"
                      label="To Date"
                      outlined
                      hide-details
                      dense
                      class="rounded-xl"
                      v-bind="attrs"
                      v-on="on"
                      clearable
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="toDate"
                    no-title
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>

              <v-flex align-self-center xl3 lg3 md3 pb-2 sm3 xs12 px-2>
                <v-select
                  v-model="status"
                  :items="statusList"
                  outlined
                  dense
                  hide-details
                  class="rounded-xl"
                  label="Status"
                  clearable
                >
                </v-select>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-card-title>
        <v-layout wrap justify-center v-if="loanList.length > 0">
          <v-flex xs12 align-self-center>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Applied Date</th>
                    <th class="text-left">Loan Amount(Rs.)</th>
                    <th class="text-left">Advance Loan(Rs.)</th>
                    <th class="text-left">Programme/Division</th>
                    <th class="text-left">Purpose</th>
                    <th class="text-left">Documents</th>
                    <th class="text-left">Status</th>
                    <th class="text-left">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="text-left align-center"
                    v-for="(item, i) in loanList"
                    :key="i"
                  >
                    <td>
                      <span
                        v-if="item.create_date"
                        class=""
                        style="font-family: kumbhMedium"
                        >{{ item.loanApplyDate.slice(0, 10) }}</span
                      >
                    </td>
                    <td>
                      <span
                        v-if="item.loanAmount"
                        class=""
                        style="font-family: kumbhMedium"
                        >{{ item.loanAmount }}</span
                      >
                    </td>
                    <td v-if="item.advanceLoanAmountExist">
                      <span v-if="item.advanceLoanAmountExist == true">{{
                        item.advanceLoanAmount
                      }}</span>
                    </td>
                    <td v-else>0</td>

                    <td>
                      <span
                        v-if="item.programmeOrDivision"
                        class=""
                        style="font-family: kumbhMedium"
                        >{{ item.programmeOrDivision }}</span
                      >
                    </td>
                    <td>
                      <span
                        v-if="item.purposeOfLoan"
                        class=""
                        style="font-family: kumbhMedium"
                        >{{ item.purposeOfLoan }}</span
                      >
                    </td>
                    <td v-if="item.loanDocument">
                      <v-icon
                        v-if="item.loanDocument.length > 0"
                        @click="(docdialog = true), (curitem = item)"
                        >mdi-file-outline</v-icon
                      ><v-icon v-else title="No documents uploaded"
                        >mdi-file-remove-outline</v-icon
                      >
                    </td>
                    <td>
                      <span
                        v-if="item.status"
                        class=""
                        style="font-family: kumbhMedium"
                        >{{ item.status }}</span
                      >
                    </td>
                    <td>
                      <span v-if="item.status === 'Pending'">
                        <v-icon
                          small
                          color="primary"
                          @click="openEditDialog(item)"
                          style="cursor: pointer"
                        >
                          mdi-pencil </v-icon
                        >&nbsp;<v-icon
                          small
                          color="red"
                          @click="handleDelete(item)"
                          style="cursor: pointer"
                          >mdi-delete</v-icon
                        >
                      </span>
                      <span>
                        <v-icon
                          small
                          color="primary"
                          @click="handleEdit(item)"
                          style="cursor: pointer"
                        >
                          mdi-eye
                        </v-icon>
                      </span>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-flex>
        </v-layout>
        <v-layout wrap v-else>
          <v-flex xs12 align-self-center pa-16>
            <span class="kumbhRegular">No Loans found!</span>
          </v-flex>
        </v-layout>
        <v-dialog persistent v-model="dialog2" width="70%">
          <v-card>
            <v-toolbar dense dark>
              <v-spacer></v-spacer>
              <v-btn right icon dark @click="(doc = null), (dialog2 = false)">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-title class="text-h5 grey lighten-2">
              Document
            </v-card-title>
            <v-card-text v-if="doc">
              <v-img :src="mediaURL + doc"></v-img>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                outlined
                small
                color="red"
                text
                @click="(dialog2 = false), (doc = null)"
              >
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- Documents Dialog -->
        <v-dialog persistent v-model="docdialog" width="70%">
          <v-card>
            <v-layout wrap>
              <v-flex xs12 pa-2 text-left>
                <span class="headline">Documents</span>
              </v-flex>
            </v-layout>
            <v-divider></v-divider>
            <v-layout wrap>
              <v-flex xs12 pa-4 text-left>
                <!-- Supporting Documents -->
                <v-subheader>Supporting Documents</v-subheader>
                <v-chip-group v-if="curitem.loanDocument">
                  <v-chip
                    v-for="(item2, i) in curitem.loanDocument"
                    :key="i"
                    class=""
                    style="font-family: kumbhMedium"
                  >
                    <span v-if="item2">
                      {{ item2 }}
                      &nbsp;
                      <span
                        v-if="
                          item2.split('.').pop() == 'pdf' ||
                          item2.split('.').pop() == 'docx'
                        "
                      >
                        <a target="_blank" :href="mediaURL + item2">
                          <v-icon small>mdi-eye</v-icon>
                        </a>
                      </span>
                      <span v-else>
                        <v-icon small @click="(doc = item2), (dialog2 = true)"
                          >mdi-eye</v-icon
                        >
                      </span>
                    </span>
                  </v-chip>
                </v-chip-group>

                <!-- Employee Signature -->
                <v-subheader class="mt-4">Signature Document</v-subheader>
                <v-chip
                  v-if="curitem.emp_sign"
                  style="font-family: kumbhMedium"
                >
                  {{ curitem.emp_sign }}
                  &nbsp;
                  <span v-if="curitem.emp_sign.split('.').pop() == 'pdf'">
                    <a target="_blank" :href="mediaURL + curitem.emp_sign">
                      <v-icon small>mdi-eye</v-icon>
                    </a>
                  </span>
                  <span v-else>
                    <v-icon
                      small
                      @click="(doc = curitem.emp_sign), (dialog2 = true)"
                      >mdi-eye</v-icon
                    >
                  </span>
                </v-chip>
              </v-flex>
            </v-layout>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="error" text @click="docdialog = false">Close</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- </v-card> -->
      </v-flex>
    </v-layout>

    <v-layout wrap justify-center v-if="pages > 1">
      <v-flex align-self-center>
        <div class="pt-2">
          <v-pagination
            prev-icon="mdi-menu-left"
            next-icon="mdi-menu-right"
            :length="pages"
            :total-visible="7"
            v-model="currentPage"
            color="#005f32"
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout>

    <v-dialog v-model="editdialog" max-width="1200px" persistent>
      <v-card>
        <v-card-title class="headline">Edit Loan Application</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <!-- Basic Details -->
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editingItem.name"
                  label="Name"
                  outlined
                  dense
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editingItem.designation"
                  label="Designation"
                  outlined
                  dense
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editingItem.grade"
                  label="Grade"
                  outlined
                  dense
                  disabled
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  :value="formatDate(editingItem.dateOfJoining)"
                  label="Date of Joining"
                  outlined
                  dense
                  disabled
                ></v-text-field>
              </v-col>

              <!-- Editable Fields -->
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editingItem.office"
                  label="Office"
                  outlined
                  dense
                  :rules="[rules.required]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editingItem.programmeOrDivision"
                  label="Programme/Division"
                  outlined
                  dense
                  :rules="[rules.required]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editingItem.loanAmount"
                  label="Loan Amount"
                  type="number"
                  outlined
                  dense
                  :rules="[rules.required]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="editingItem.tobeReleasedBy"
                  :items="['Finance']"
                  label="To be Released By"
                  outlined
                  dense
                  :rules="[rules.required]"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model="editingItem.presentNetSalaryPerMonth"
                  label="Present Net Salary Per Month"
                  type="number"
                  outlined
                  dense
                  :rules="[rules.required]"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-textarea
                  v-model="editingItem.purposeOfLoan"
                  label="Purpose of Loan"
                  outlined
                  dense
                  :rules="[rules.required]"
                ></v-textarea>
              </v-col>

              <!-- Advance Loan Section -->
              <v-col cols="12" class="text-left">
                <span
                  >As on date, iIs there any advance/ loan amount outstanding
                  against you?</span
                >
                <v-radio-group
                  v-model="editingItem.advanceLoanAmountExist"
                  row
                  mandatory
                >
                  <v-radio label="Yes" :value="true"></v-radio>
                  <v-radio label="No" :value="false"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12" md="6" v-if="editingItem.advanceLoanAmountExist">
                <v-text-field
                  v-model="editingItem.advanceLoanAmount"
                  label="Existing Advance/Loan Amount"
                  type="number"
                  outlined
                  dense
                  :rules="[rules.required]"
                ></v-text-field>
              </v-col>

              <!-- Add this inside the edit dialog, after the form fields -->
              <v-flex xs12 pa-2>
                <v-layout wrap justify-start>
                  <v-flex xs12 text-left>
                    <span>Supporting Document</span>
                  </v-flex>
                  <v-flex
                    xs11
                    sm11
                    md11
                    lg11
                    pa-8
                    align-self-center
                    text-center
                    style="
                      border-style: dotted;
                      border-color: #3574c6;
                      border-radius: 5px;
                      cursor: pointer;
                      background-color: white;
                    "
                    @click="$refs.editFileInput.click()"
                  >
                    <v-layout wrap justify-center pt-0>
                      <v-flex xs12 sm12 md12 lg12>
                        <v-layout wrap justify-center>
                          <v-flex
                            xs12
                            sm4
                            md3
                            lg2
                            text-center
                            align-self-center
                            fill-height
                          >
                            <v-img
                              src="@/assets/images/upload.png"
                              contain
                              height="50px"
                              alt="upload"
                              width="100px"
                            ></v-img>
                          </v-flex>
                          <v-flex xs12 text-center>
                            <span
                              style="
                                font-size: 16px;
                                font-weight: 600;
                                color: #676767;
                              "
                            >
                              {{
                                editSelectedFileName ||
                                "Click to upload supporting document"
                              }}
                            </span>
                          </v-flex>
                        </v-layout>
                        <input
                          ref="editFileInput"
                          v-show="false"
                          type="file"
                          @change="handleEditFileUpload"
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>

              <v-flex xs12 pa-2>
                <v-layout wrap justify-start>
                  <v-flex xs12 text-left>
                    <span>Signature or Thumb impression of the Applicant</span>
                  </v-flex>
                  <v-flex
                    xs11
                    sm11
                    md11
                    lg11
                    pa-8
                    align-self-center
                    text-center
                    style="
                      border-style: dotted;
                      border-color: #3574c6;
                      border-radius: 5px;
                      cursor: pointer;
                      background-color: white;
                    "
                    @click="$refs.editSignatureInput.click()"
                  >
                    <v-layout wrap justify-center pt-0>
                      <v-flex xs12 sm12 md12 lg12>
                        <v-layout wrap justify-center>
                          <v-flex
                            xs12
                            sm4
                            md3
                            lg2
                            text-center
                            align-self-center
                            fill-height
                          >
                            <v-img
                              src="@/assets/images/upload.png"
                              contain
                              height="50px"
                              alt="upload"
                              width="100px"
                            ></v-img>
                          </v-flex>
                          <v-flex xs12 text-center>
                            <span
                              style="
                                font-size: 16px;
                                font-weight: 600;
                                color: #676767;
                              "
                            >
                              {{
                                editSignatureFileName ||
                                "Click to upload signature or thumb impression"
                              }}
                            </span>
                          </v-flex>
                        </v-layout>
                        <input
                          ref="editSignatureInput"
                          v-show="false"
                          type="file"
                          accept="image/*,.pdf"
                          @change="handleEditSignatureUpload"
                        />
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="editdialog = false"
            >Cancel</v-btn
          >
          <v-btn color="green darken-1" text @click="saveEdit"
            >Save Changes</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- <v-dialog v-model="deleteDialog" max-width="400">
      <v-card>
        <v-card-title class="headline">Confirm Delete</v-card-title>
        <v-card-text>Are you sure you want to delete this document?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="red" @click="deleteDocument" dark>Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog> -->
    <v-dialog persistent v-model="deleteDialog" max-width="600px">
      <v-card>
        <v-layout wrap>
          <v-flex
            xs12
            align-self-center
            pa-4
            style="background: #005f32"
            text-left
          >
            <span class="kumbhBold" style="color: #ffffff">Confirmation</span>
          </v-flex>
        </v-layout>
        <v-layout wrap pa-6>
          <v-flex xs12 align-self-end pa-3>
            <span class="kumbhMedium"
              >Are you sure you want to delete this loan application?</span
            >
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="error" tile dark @click="deleteDialog = false"
            >Cancel</v-btn
          >
          &nbsp;
          <v-btn color="#005f32" outlined tile @click="confirmDelete"
            >Confirm</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- <v-dialog persistent v-model="deleteDialog" max-width="700px">
      <v-card>
        <v-layout wrap>
          <v-flex
            xs12
            pa-4
            text-left
            align-self-center
            style="background: #005f32 !important"
          >
            <v-layout wrap>
              <v-flex xs6 align-self-center text-left>
                <span class="kumbhBold" style="color: #ffffff; font-size: 20px">
                  Delete Document</span
                >
              </v-flex>
              <v-flex xs6 align-self-center text-right>
                <v-btn
                  icon
                  color="white"
                  text
                  @click="(deleteDialog = false), getData()"
                >
                  <v-icon color="#ffffff">mdi-close</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs12>
            <v-layout wrap justify-start>
              <v-flex xs12 text-start pa-4 class="itemHeading">
                Are you sure you want to delete this document?
              </v-flex>
              <v-flex xs12 text-end pt-3 pa-4>
                <v-btn @click="deleteDocument" color="#005f32">
                  <span class="kumbhBold" style="color: white"> Delete</span>
                </v-btn></v-flex
              >
            </v-layout>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog> -->
  </div>
</template>
<script>
// import ImageComp from  "@/components/Common/singleImage";
import axios from "axios";
export default {
  data() {
    return {
      show: false,
      showsnackbar: false,
      ServerError: false,
      msg: null,
      pages: 0,
      dialog: false,
      editdialog: false,
      deleteDialog: false,
      itemToDelete: null,
      // editingitem: [],
      pageCount: 1,
      appLoading: false,
      editedIndex: -1,
      currentPage: 1,
      g: false,
      totalData: 0,
      addcat: false,
      rules: {
        required: (value) => !!value || "Required.",
      },
      idd: null,
      loanList: [],
      data: [],
      //view doc
      curitem: [],
      docdialog: false,
      dialog2: false,
      doc: null,

      //
      coverImageFile: null,
      selectedFiles: [],
      image: null,
      coverImageArray: [],
      formDataCover: new FormData(),
      name: null,
      assetId: null,
      assetList: [],
      date: new Date(),
      fromDate: new Date(),
      toDate: new Date(),
      menu1: false,
      menu2: false,
      status: null,

      statusList: ["Pending", "Approved", "Rejected"],
      employeeId: null,
      departmentId: null,
      search1: null,

      empList: [],
      deptList: [],
      quantity: null,

      editDialog: false,
      editingItem: {},
      documentFile1: [],
      docsdata: new FormData(),
      selectedDocument: null,
      selectedItemId: null,

      editSelectedFileName: null,
      editSelectedFile: null,
      editSignatureFileName: null,
      editSignatureFile: null,
    };
  },
  components: {
    // ImageComp,
  },
  computed: {
    userId() {
      return this.$store.state.userData._id;
    },
  },
  watch: {
    fromDate() {
      if (this.currentPage > 1) this.currentPage = 1;
      this.getData();
    },
    toDate() {
      if (this.currentPage > 1) this.currentPage = 1;
      this.getData();
    },
    status() {
      if (this.currentPage > 1) this.currentPage = 1;
      this.getData();
    },
  },
  mounted() {
    this.getData();
    if (this.fromDate) {
      this.fromDate = null;
    }
    if (this.toDate) {
      this.toDate = null;
    }
    if (this.userId) {
      this.getData();
    }
  },

  methods: {
    handleEdit(item) {
      this.$router.push({
        path: "/ViewLoanApplication",
        query: { id: item._id },
      });
    },
    formatDate(date) {
      if (!date) return "";
      const d = new Date(date);
      const day = String(d.getDate()).padStart(2, "0");
      const month = String(d.getMonth() + 1).padStart(2, "0");
      const year = d.getFullYear();
      return `${day}-${month}-${year}`;
    },
    handleDelete(item) {
      this.itemToDelete = item;
      this.deleteDialog = true;
    },
    openEditDialog(item) {
      this.editingItem = { ...item };
      this.editdialog = true;
    },
    confirmDelete() {
      this.appLoading = true;
      axios({
        url: "/employee/loan/cancel",
        method: "POST",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: {
          id: this.itemToDelete._id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.deleteDialog = false;
          if (response.data.status) {
            this.msg = "Application deleted successfully";
            this.showsnackbar = true;
            this.getData();
          } else {
            this.msg = response.data.msg || "Failed to delete application";
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.deleteDialog = false;
          this.msg = "Error deleting application";
          this.showsnackbar = true;
          console.log(err);
        })
        .finally(() => {
          this.itemToDelete = null;
        });
    },
    removeDocument(i) {
      this.documentFile1.splice(i, 1);
    },
    browseCover(event) {
      var got = event.target.files;
      if (got.length < 5) {
        for (let i = 0; i < got.length; i++) {
          this.documentFile1.push(got[i]);
        }
        console.log("file isss", this.documentFile1);
      } else {
        this.msg = "Maximum 3 can be uploaded";
        this.showSnackBar = true;
      }
    },

    handleEditFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.editSelectedFile = file;
        this.editSelectedFileName = file.name;
      }
    },

    handleEditSignatureUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.editSignatureFile = file;
        this.editSignatureFileName = file.name;
      }
    },

    saveEdit() {
      const formData = new FormData();

      // Add all the form fields
      formData.append("id", this.editingItem._id);
      formData.append("name", this.editingItem.name);
      formData.append("designation", this.editingItem.designation);
      formData.append("grade", this.editingItem.grade);
      formData.append("office", this.editingItem.office);
      formData.append("dateOfJoining", this.editingItem.dateOfJoining);
      formData.append(
        "programmeOrDivision",
        this.editingItem.programmeOrDivision
      );
      formData.append("loanAmount", this.editingItem.loanAmount);
      formData.append("tobeReleasedBy", this.editingItem.tobeReleasedBy);
      formData.append(
        "presentNetSalaryPerMonth",
        this.editingItem.presentNetSalaryPerMonth
      );
      formData.append(
        "advanceLoanAmountExist",
        this.editingItem.advanceLoanAmountExist
      );
      formData.append("advanceLoanAmount", this.editingItem.advanceLoanAmount);
      formData.append("purposeOfLoan", this.editingItem.purposeOfLoan);
      formData.append("fyear", this.editingItem.fyear);

      // Add new files if uploaded
      if (this.editSelectedFile) {
        formData.append("supportDoc", this.editSelectedFile);
      }
      if (this.editSignatureFile) {
        formData.append("empSign", this.editSignatureFile);
      }

      axios
        .post("/employee/loan/edit", formData, {
          headers: {
            "x-auth-token": localStorage.getItem("token"),
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.status) {
            this.msg = "Updated Successfully";
            this.showsnackbar = true;
            this.editdialog = false;
            this.getData();

            // Reset file upload states
            this.editSelectedFileName = null;
            this.editSelectedFile = null;
            this.editSignatureFileName = null;
            this.editSignatureFile = null;
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          console.error(err);
          this.msg = "Error updating loan application";
          this.showsnackbar = true;
        });
    },

    docsupload() {
      for (var i = 0; i < this.documentFile1.length; i++) {
        this.docsdata.append("document", this.documentFile1[i]);
      }
      this.docsdata.append("id", this.documentID);

      this.appLoading = true;
      axios({
        url: "/upload/loandocuments",
        method: "post",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        data: this.docsdata,
      })
        .then((response) => {
          if (response.data.status) {
            this.appLoading = false;
            // this.dialog = false;
            this.documentFile1 = [];

            this.docsdata = new FormData();
            this.msg = response.data.msg;
            this.editdialog = false;
            this.getData();
          } else {
            this.appLoading = false;
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    //  userdata() {
    //   this.appLoading = true;
    //   axios({
    //     method: "get",
    //     url: "/employee/profile/me",
    //     headers: {
    //       "x-auth-token": localStorage.getItem("token"),
    //     },
    //   })
    //     .then((response) => {
    //       this.appLoading = false;
    //       if (response.data.status==true) {
    //         this.idd=response.data.data._id;
    //         console.log("idd=",this.idd)
    //         this.getData();
    //       }
    //     })
    //     .catch((err) => {
    //       this.appLoading = false;
    //       console.log(err);
    //     });
    // },
    getData() {
      this.appLoading = true;
      axios({
        url: "/employee/loan/list",
        method: "get",
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
        params: {
          status: this.status,
          page: this.currentPage,
          limit: 20,
          fromDate: this.fromDate,
          toDate: this.toDate,
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.loanList = response.data.data;
          this.totalData = response.data.totalRecords;
          this.pages = Math.ceil(this.totalData / response.data.perPage);
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
    dialogclose() {
      this.name = null;
      this.dialog = false;
    },

    // confirmDelete(doc, itemId) {
    //   this.selectedDocument = doc;
    //   this.selectedItemId = itemId;
    //   this.deleteDialog = true;
    // },
    // deleteDocument() {
    //   const data = {
    //     documentName: this.selectedDocument,
    //     loanid: this.selectedItemId,
    //   };

    //   axios({
    //     url: "/loan/document/delete",
    //     method: "POST",
    //     headers: {
    //       "x-auth-token": localStorage.getItem("token"),
    //     },
    //     data: data,
    //   })
    //     .then((response) => {
    //       this.deleteDialog = false;

    //       if (response.data.status) {
    //         // Remove the deleted document from the local list
    //         const index = this.editingItem.loanDocument.indexOf(
    //           this.selectedDocument
    //         );
    //         if (index !== -1) {
    //           this.editingItem.loanDocument.splice(index, 1);
    //         }

    //         this.msg = "Deleted Successfully";
    //         this.showsnackbar = true;

    //         // Fetch the updated list
    //         this.getData();
    //       } else {
    //         this.msg = response.data.msg;
    //         this.showsnackbar = true;
    //       }
    //     })
    //     .catch((err) => {
    //       this.deleteDialog = false;
    //       console.error("Error deleting document:", err);
    //     });
    // },

    editcat(item) {
      this.editingitem = item;

      this.getEmp();
      // if (item.departmentId) this.departmentId = item.departmentId._id;
      // if (item.employeeId) this.employeeId = item.employeeId._id;
      this.editdialog = true;
    },
    validateEdit() {
      if (this.quantity > this.editingitem.quantity) {
        this.msg =
          "Quantity should be less than or same as already assigned quantity!";
        this.showsnackbar = true;
        return;
      } else if (!this.assignType) {
        this.msg = "Please provide assign type";
        this.showsnackbar = true;
        return;
      } else if (!this.departmentId) {
        this.msg = "Please choose a department";
        this.showsnackbar = true;
        return;
      } else if (this.assignType == "Employee" && !this.employeeId) {
        this.msg = "Please choose an employee";
        this.showsnackbar = true;
        return;
      } else {
        this.edit();
      }
    },
    edit() {
      var data = {};
      data["inventoryStockId"] = this.editingitem._id;
      data["assignType"] = this.assignType;
      data["departmentId"] = this.departmentId;
      data["employeeId"] = this.employeeId;
      data["quantity"] = this.quantity;
      axios({
        url: "/asset/reassign/transfer",
        method: "POST",
        data: data,
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.editdialog = false;

          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Edited Sucessfully";
            this.showsnackbar = true;
            console.log("4");
            this.getData();
            this.clearOff();
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    clearOff() {
      this.employeeId = null;
      this.assignType = null;
      this.quantity = null;
      this.departmentId = null;
    },
  },
};
</script>
